import { useCallback, useState } from 'react';
import type { AutomationEditAction } from '../../../features/EditBlock/store';
import type { AutomationEditType } from '../../../features/EditBlock/types';

interface UseAddEditActionProps {
	onAddEditAction: (type: AutomationEditType) => AutomationEditAction;
	close: () => void;
}

export function useAddEditAction({
	onAddEditAction,
	close,
}: UseAddEditActionProps) {
	const [createdEditAction, setCreatedEditAction] =
		useState<AutomationEditAction | null>(null);

	const reset = useCallback(() => {
		setCreatedEditAction(null);
	}, []);

	const handleAddEditAction = useCallback(
		(type: AutomationEditType, shouldClose: boolean) => {
			const result = onAddEditAction(type);
			setCreatedEditAction(result);

			if (shouldClose) {
				close();
			}
		},
		[close, onAddEditAction]
	);

	return {
		createdEditAction,
		handleAddEditAction,
		reset,
	};
}
